import { DocumentVersionGeneratedEntity } from "./generated/DocumentVersionGeneratedEntity";

export abstract class DocumentVersionEntity extends DocumentVersionGeneratedEntity {
    // Comment to preserve new line
}
